<template>
  <el-card style="width: 32%;">
    <div ref="statistics" style="height: 350px;" v-show="statisticsData && statisticsData.length"></div>
    <el-empty description="暂无数据" v-show="!statisticsData || !statisticsData.length"></el-empty>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    statisticsData: Object
  },
  data() {
    return {
      myCharts: null
    }
  },
  mounted() {
    let el = this.$refs.statistics;
    el.style.width = el.parentNode.clientWidth - 40 + 'px';
  },
  watch: {
    statisticsData: {
      handler(val) {
        this.setChart();
      },
      deep: true
    }
  },
  methods: {
    setChart() {
      if (!this.myCharts) {
        this.myCharts = this.$echarts.init(this.$refs.statistics);
      }
      let statisticsData = this.statisticsData;
      if (!statisticsData || !statisticsData.length) {
        return;
      }

      let axisData = [];
      let avgSalaryData = [];
      let actualSalaryData = [];
      for (let index in statisticsData) {
        let workType = statisticsData[index];
        axisData.push(workType.name);
        avgSalaryData.push(workType.avgSalary)
        actualSalaryData.push(workType.actualSalary)
      }

      this.myCharts.setOption({
        title: {
          text: '工种月薪分布',
          left: 'center'
        },

        tooltip: {
        },
        grid: {
          left: '3%',
          right: '1%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: axisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '平均月薪',
            data: avgSalaryData,
            type: 'line',
            stack: 'total',
            areaStyle: {}
          },
          {
            name: '最高月薪',
            data: actualSalaryData,
            type: 'line',
            stack: 'total',
            areaStyle: {}
          }
        ]
      })
    }
  }
})
</script>
